import { createStore } from 'vuex'

export default createStore({
  state: {
    appearMenu : false,
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
